import { FilterSet } from "./filter-interface";

export interface TileFavoriteInterface {
  id: string;
  title: string;
  subtitle?: string;
  link?: string;
  textDisclaimer?: string;
  isExternalLink?: boolean;
}

export enum SearchType {
  VideoSearch = "VideoSearch",
  JobSearch = "JobSearch",
  MobilityReferentSearch = "MobilityReferentSearch",
  JourneySearch = "JourneySearch",
}

export interface FavoriteSearchResearchDataInterface {
  selectedFilters: FilterSet[];
  locationSearchValue?: string;
}

export interface FavoriteFilterSearchInterface {
  id: number;
  vinciId: string;
  name: string;
  searchType: SearchType;
  research: FavoriteSearchResearchDataInterface;
  createdAt?: Date;
}

export interface CreateFavoriteFilterSearchRequestInterface {
  name: string;
  searchType: SearchType;
  research: FavoriteSearchResearchDataInterface;
}
